<template>
  <div class="px-10 pb-10 pt-2 flex gap-4 justify-end">
    <slot>
      <b-button size="sm" light @click="emit('cancel')"
        >{{ t('modal_footer.cancel') }}</b-button
      >
      <b-button
        size="sm"
        variant="primary"
        @click="emit('add')"
        :loading="props.loading"
        >{{ t('modal_footer.validate') }}</b-button
      >
    </slot>
  </div>
</template>

<script setup lang="ts">
import BButton from "~/components/forms/BButton.vue";

const { t } = useI18n();

interface Props {
  loading?: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits(["cancel", "add"]);
</script>

<style scoped></style>
